import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EmptyStateIllustration = () => /*#__PURE__*/_jsxs("svg", {
  width: "615",
  height: "418",
  viewBox: "0 0 615 418",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsxs("g", {
    opacity: "0.7",
    clipPath: "url(#clip0_154_17074)",
    children: [/*#__PURE__*/_jsx("path", {
      opacity: "0.14",
      d: "M378.5 419C492.547 419 585 326.547 585 212.5C585 98.4532 492.547 6 378.5 6C264.453 6 172 98.4532 172 212.5C172 326.547 264.453 419 378.5 419Z",
      fill: "url(#paint0_radial_154_17074)"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.4",
      d: "M283.5 384C384.292 384 466 302.292 466 201.5C466 100.708 384.292 19 283.5 19C182.708 19 101 100.708 101 201.5C101 302.292 182.708 384 283.5 384Z",
      fill: "url(#paint1_radial_154_17074)"
    })]
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter0_dd_154_17074)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M458.52 223.341L336.785 190.425C333.112 189.05 327.917 190.1 325.766 192.239L205.733 312.016C205.275 312.473 204.642 312.698 204.342 313.35C203.378 315.44 206.988 321.163 209.562 321.853L334.618 355.361C337.557 356.149 341.684 355.054 343.835 352.915L462.615 234.263C465.801 230.167 461.459 224.129 458.52 223.341Z",
      fill: "url(#paint2_linear_154_17074)"
    })
  }), /*#__PURE__*/_jsx("path", {
    d: "M457.169 222.658L334.256 189.724C331.056 188.866 326.561 190.071 324.218 192.414L205.924 310.708C203.581 313.051 204.276 315.646 207.477 316.504L328.457 348.92C332.725 350.064 338.717 348.458 341.842 345.334L458.722 228.454C461.065 226.111 460.37 223.516 457.169 222.658Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter1_f_154_17074)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M342.731 347.675L459.199 229.104C461.384 226.879 460.853 224.422 457.98 223.465L450.784 221.066L335.15 190.603C331.953 189.761 327.486 190.962 325.148 193.292L206.528 311.527C204.197 313.85 204.852 316.428 207.996 317.31L329.186 351.292C333.483 352.497 339.599 350.863 342.731 347.675Z",
      fill: "url(#paint3_linear_154_17074)"
    })
  }), /*#__PURE__*/_jsx("path", {
    d: "M457.169 222.658L334.256 189.724C331.056 188.866 326.561 190.071 324.218 192.414L205.924 310.708C203.581 313.051 204.276 315.646 207.477 316.504L328.457 348.92C332.725 350.064 338.717 348.458 341.842 345.334L458.722 228.454C461.065 226.111 460.37 223.516 457.169 222.658Z",
    fill: "url(#paint4_linear_154_17074)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M338.997 221.561C338.864 221.098 338.047 220.979 337.387 220.809L284.098 207.105C283.519 206.95 282.731 207.108 282.07 207.468C281.51 207.774 281.09 208.172 280.575 208.509L279.549 209.181C279.034 209.519 278.547 209.894 278.415 210.309C278.164 211.092 278.382 212.101 279.007 212.269L333.201 226.79C334.016 227.008 335.245 226.607 335.948 225.894L338.493 223.312C338.941 222.858 339.143 222.072 338.997 221.561Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M338.292 220.716L284.098 206.195C283.284 205.977 282.055 206.378 281.351 207.091L278.806 209.673C278.103 210.386 278.193 211.141 279.007 211.359L333.202 225.88C334.016 226.098 335.245 225.697 335.948 224.984L338.493 222.402C339.197 221.689 339.106 220.934 338.292 220.716Z",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("path", {
    d: "M345.635 238.659C345.325 238.392 344.726 238.332 344.229 238.203L271.876 219.395C271.192 219.212 270.368 219.274 269.675 219.52C268.843 219.815 268.247 220.368 267.522 220.785L266.892 221.147C266.166 221.563 265.502 222.066 265.496 222.598C265.487 223.392 266.023 224.355 266.805 224.564L339.943 244.161C341.043 244.456 342.5 244.116 343.2 243.402L345.736 240.818C346.276 240.266 346.222 239.164 345.635 238.659Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M344.763 238.015L271.625 218.418C270.526 218.123 269.068 218.463 268.368 219.177L265.833 221.762C265.133 222.476 265.456 223.293 266.555 223.587L339.693 243.184C340.792 243.479 342.249 243.139 342.95 242.425L345.485 239.84C346.185 239.126 345.862 238.31 344.763 238.015Z",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("path", {
    d: "M299.054 259.675C298.943 259.194 298.11 259.065 297.433 258.892L245.564 245.567C244.995 245.415 244.209 245.581 243.551 245.95C243.011 246.254 242.602 246.641 242.103 246.971L241.048 247.669C240.548 247.999 240.075 248.365 239.936 248.77C239.668 249.552 239.86 250.566 240.472 250.73L293.262 264.875C294.055 265.088 295.267 264.682 295.971 263.969L298.517 261.388C298.955 260.943 299.17 260.183 299.054 259.675Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M298.373 258.807L245.583 244.662C244.79 244.45 243.578 244.855 242.874 245.568L240.328 248.15C239.625 248.863 239.698 249.613 240.491 249.825L293.281 263.97C294.074 264.183 295.286 263.777 295.99 263.064L298.536 260.483C299.239 259.769 299.166 259.02 298.373 258.807Z",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("path", {
    d: "M298.315 241.908C298.119 241.622 297.649 241.487 297.185 241.374L257.772 231.772C257.302 231.647 256.549 231.898 255.905 232.359C255.542 232.618 255.236 232.905 254.876 233.167L253.567 234.119C253.207 234.38 252.865 234.658 252.692 234.964C252.258 235.736 252.177 236.801 252.666 236.932L292.325 247.559C292.921 247.718 294.447 247.262 295.153 246.55L297.883 243.819C298.44 243.257 298.685 242.448 298.315 241.908Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M297.623 241.541L257.963 230.914C257.368 230.754 256.314 231.202 255.608 231.915L253.055 234.494C252.35 235.207 252.262 235.914 252.857 236.073L292.517 246.7C293.113 246.86 294.167 246.412 294.872 245.699L297.425 243.119C298.13 242.407 298.219 241.7 297.623 241.541Z",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("path", {
    d: "M306.438 279.61C306.128 279.344 305.529 279.283 305.031 279.154L232.678 260.346C231.994 260.163 231.171 260.226 230.478 260.471C229.646 260.766 229.05 261.319 228.324 261.736L227.695 262.098C226.969 262.515 226.305 263.018 226.299 263.549C226.29 264.344 226.826 265.306 227.608 265.516L300.746 285.113C301.845 285.407 303.303 285.068 304.003 284.354L306.538 281.769C307.079 281.218 307.025 280.115 306.438 279.61Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M305.565 278.966L232.427 259.369C231.328 259.075 229.87 259.414 229.17 260.128L226.635 262.713C225.934 263.427 226.258 264.244 227.356 264.538L300.495 284.135C301.594 284.43 303.051 284.09 303.751 283.376L306.287 280.792C306.987 280.078 306.664 279.261 305.565 278.966Z",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("path", {
    d: "M259.12 282.86C258.924 282.573 258.454 282.438 257.99 282.325L218.577 272.724C218.107 272.598 217.353 272.849 216.71 273.31C216.347 273.57 216.04 273.856 215.681 274.118L214.371 275.07C214.012 275.332 213.67 275.609 213.497 275.916C213.063 276.687 212.982 277.752 213.47 277.883L253.13 288.51C253.726 288.67 255.252 288.214 255.957 287.501L258.688 284.771C259.245 284.208 259.489 283.399 259.12 282.86Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M258.427 282.492L218.768 271.865C218.172 271.706 217.118 272.153 216.413 272.866L213.86 275.446C213.155 276.158 213.066 276.865 213.662 277.025L253.321 287.651C253.917 287.811 254.971 287.363 255.677 286.651L258.23 284.071C258.935 283.358 259.023 282.652 258.427 282.492Z",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("path", {
    d: "M326.261 213.258C325.342 213.012 324.661 212.633 324.219 212.121C323.787 211.612 323.618 211.032 323.714 210.379C323.826 209.723 324.208 209.064 324.86 208.402C325.513 207.74 326.315 207.198 327.267 206.775C328.235 206.348 329.242 206.079 330.288 205.965C331.343 205.855 332.33 205.923 333.25 206.169C334.106 206.399 334.754 206.748 335.192 207.217C335.645 207.681 335.858 208.211 335.83 208.806L333.834 209.062C333.85 208.665 333.707 208.312 333.405 208.006C333.119 207.695 332.692 207.463 332.124 207.311C331.52 207.149 330.866 207.108 330.161 207.187C329.463 207.259 328.787 207.442 328.133 207.735C327.495 208.024 326.954 208.394 326.51 208.844C326.066 209.294 325.801 209.742 325.715 210.188C325.645 210.629 325.753 211.022 326.04 211.367C326.334 211.705 326.783 211.955 327.387 212.117C327.955 212.269 328.561 212.318 329.206 212.265C329.867 212.208 330.502 212.06 331.113 211.822L331.876 212.817C330.964 213.176 330.011 213.397 329.015 213.482C328.036 213.562 327.118 213.488 326.261 213.258ZM340.328 207.84L333.281 214.989L331.766 214.583L338.814 207.434L340.328 207.84ZM341.672 209.756C341.401 209.684 341.237 209.556 341.178 209.373C341.135 209.186 341.211 208.993 341.407 208.794C341.609 208.589 341.866 208.444 342.176 208.36C342.496 208.279 342.791 208.274 343.062 208.346C343.341 208.421 343.506 208.549 343.556 208.73C343.615 208.913 343.543 209.107 343.34 209.312C343.145 209.511 342.884 209.654 342.557 209.743C342.246 209.827 341.951 209.831 341.672 209.756ZM340.073 210.407L341.587 210.813L336.595 215.877L335.081 215.471L340.073 210.407ZM347.724 215.671C347.574 215.823 347.417 215.965 347.253 216.097L341.668 214.6C341.435 214.998 341.41 215.359 341.591 215.684C341.772 216.009 342.143 216.246 342.701 216.396C343.134 216.512 343.601 216.553 344.101 216.52C344.601 216.486 345.053 216.398 345.456 216.255L345.847 217.176C345.16 217.41 344.451 217.546 343.718 217.584C342.994 217.625 342.312 217.559 341.672 217.388C340.951 217.195 340.412 216.904 340.054 216.515C339.705 216.129 339.563 215.689 339.628 215.196C339.708 214.698 339.996 214.198 340.492 213.695C340.975 213.205 341.573 212.801 342.287 212.482C343.009 212.165 343.756 211.967 344.528 211.89C345.316 211.808 346.047 211.858 346.723 212.039C347.409 212.222 347.912 212.504 348.233 212.883C348.555 213.262 348.675 213.695 348.592 214.184C348.509 214.672 348.22 215.168 347.724 215.671ZM346.571 214.759C346.807 214.37 346.844 214.021 346.683 213.71C346.538 213.395 346.217 213.171 345.721 213.038C345.234 212.907 344.703 212.903 344.127 213.025C343.558 213.14 343.034 213.36 342.555 213.683L346.571 214.759ZM355.507 214.392C356.327 214.612 356.806 214.97 356.943 215.467C357.089 215.967 356.865 216.517 356.271 217.12L353.129 220.307L351.614 219.901L354.394 217.081C354.779 216.691 354.928 216.337 354.841 216.021C354.769 215.701 354.472 215.471 353.949 215.33C353.399 215.183 352.837 215.187 352.262 215.343C351.693 215.492 351.217 215.761 350.832 216.152L348.071 218.952L346.557 218.546L351.549 213.482L353.063 213.888L352.417 214.543C353.494 214.179 354.524 214.129 355.507 214.392ZM358.319 219.602C358.091 219.833 358.004 220.032 358.057 220.197C358.111 220.362 358.3 220.488 358.625 220.575C358.932 220.657 359.306 220.682 359.748 220.65L358.72 221.692C358.204 221.73 357.717 221.687 357.257 221.564C356.527 221.368 356.114 221.082 356.018 220.705C355.929 220.321 356.133 219.878 356.629 219.375L359.164 216.803L358.001 216.491L358.999 215.479L360.162 215.79L361.454 214.48L362.969 214.885L361.677 216.196L363.624 216.718L362.626 217.731L360.678 217.209L358.319 219.602ZM362.117 222.866C361.008 222.569 360.307 222.055 360.014 221.323L361.571 220.749C361.748 221.298 362.237 221.681 363.039 221.896C363.436 222.002 363.809 222.039 364.16 222.008C364.519 221.978 364.784 221.878 364.953 221.706C365.129 221.527 365.138 221.362 364.98 221.211C364.828 221.053 364.542 220.863 364.122 220.642C363.702 220.42 363.369 220.214 363.124 220.023C362.889 219.834 362.75 219.605 362.709 219.334C362.668 219.064 362.817 218.757 363.157 218.413C363.646 217.916 364.286 217.602 365.076 217.471C365.867 217.34 366.654 217.379 367.438 217.589C368.439 217.857 369.092 218.317 369.396 218.967L367.825 219.538C367.629 219.067 367.192 218.741 366.516 218.56C366.155 218.463 365.812 218.43 365.487 218.459C365.176 218.485 364.94 218.581 364.776 218.746C364.6 218.925 364.587 219.089 364.737 219.238C364.895 219.389 365.193 219.578 365.632 219.804C366.049 220.016 366.376 220.216 366.611 220.405C366.856 220.596 366.999 220.827 367.04 221.097C367.081 221.368 366.935 221.672 366.603 222.009C366.1 222.519 365.435 222.847 364.607 222.993C363.785 223.133 362.955 223.091 362.117 222.866Z",
    fill: "#282863"
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("filter", {
      id: "filter0_dd_154_17074",
      x: "184.182",
      y: "159.806",
      width: "299.551",
      height: "223.811",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_154_17074"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_154_17074",
        result: "effect2_dropShadow_154_17074"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_154_17074",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter1_f_154_17074",
      x: "204.132",
      y: "189.334",
      width: "257.411",
      height: "163.354",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "0.5",
        result: "effect1_foregroundBlur_154_17074"
      })]
    }), /*#__PURE__*/_jsxs("radialGradient", {
      id: "paint0_radial_154_17074",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(378.5 212.5) scale(206.5)",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#FF8FE6"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#FF8FE6",
        stopOpacity: "0"
      })]
    }), /*#__PURE__*/_jsxs("radialGradient", {
      id: "paint1_radial_154_17074",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(283.5 201.5) scale(182.5)",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#8296FF",
        stopOpacity: "0.6"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#8296FF",
        stopOpacity: "0"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint2_linear_154_17074",
      x1: "465.33",
      y1: "219.832",
      x2: "191.251",
      y2: "152.605",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#8B98DE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.200284",
        stopColor: "#C1CBFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.303741",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.310958",
        stopColor: "#DDE2FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.333069",
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.491969",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.857402",
        stopColor: "#94A0E3"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#DAE0FF"
      })]
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "paint3_linear_154_17074",
      x1: "463.981",
      y1: "213.33",
      x2: "-53.2373",
      y2: "882.82",
      gradientUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      })
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "paint4_linear_154_17074",
      x1: "463.07",
      y1: "212.42",
      x2: "-54.1486",
      y2: "881.91",
      gradientUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_154_17074",
      children: /*#__PURE__*/_jsx("rect", {
        width: "615",
        height: "418",
        fill: "white"
      })
    })]
  })]
});